import * as React from 'react';
import { LinkUniversal } from '@duxton-web/icons';
import { ConfigProvider, Flex, Typography } from '@duxton-web/ui';

// import { RouterState } from 'connected-react-router'; // Removed in v6

import AccessControlTable from './AccessControlTable';
import UserRolesLegend from './UserRolesLegend';
import { ObjectDetailPage } from '@/common/components';
import { CurrentUser, UserRoles } from '@/lib/PlannerDTOs';

interface StateProps {
  isFetchingUsers: boolean;
  users: UserRoles[];
  // router: RouterState; // Removed in v6
  currentUser: CurrentUser;
}

interface DispatchProps {
  fetchCurrentUser: () => Promise<{ currentUser: CurrentUser }>;
  // pushToHistory: (url?: string) => void; // Removed in v6 - use useNavigate instead
}

export class UserRolesPage extends React.Component<StateProps & DispatchProps> {
  render() {
    return (
      <ObjectDetailPage>
        <Flex
          vertical
          gap={16}
          style={{
            padding: 24,
            height: '100%',
          }}
        >
          <ConfigProvider
            theme={{
              components: {
                Typography: {
                  titleMarginBottom: 0,
                },
              },
            }}
          >
            <Typography.Title level={3}>Access Control</Typography.Title>
          </ConfigProvider>

          <ul
            style={{
              paddingLeft: 20,
            }}
          >
            <li>
              There is a&nbsp;
              <a
                href="https://go/grabx-access-request"
                target="_blank"
                rel="noreferrer"
              >
                guide <LinkUniversal />
              </a>
              &nbsp;which can help you to understand how to raise request
            </li>
          </ul>

          <UserRolesLegend />
          <AccessControlTable />
        </Flex>
      </ObjectDetailPage>
    );
  }
}

export default UserRolesPage;
